// src/lib/scan.ts
// Wedge-Puffer (R3): PDA-Scanner tippen als Tastatur mit Enter-Suffix.
// Heuristik: Scanner sind schnell (< 80 ms/Zeichen) — langsame Eingaben sind Menschen.
export type WedgeBuffer = { onKey: (key: string, ts: number) => void; reset: () => void }

const MAX_CHAR_GAP_MS = 80
const MIN_CODE_LEN = 4

export function createWedgeBuffer(onScan: (code: string) => void): WedgeBuffer {
  let chars: string[] = []
  let lastTs = 0
  let humanSpeed = false
  return {
    onKey(key, ts) {
      if (key === 'Enter') {
        const code = chars.join('')
        const ok = !humanSpeed && code.length >= MIN_CODE_LEN
        chars = []; humanSpeed = false
        if (ok) onScan(code)
        return
      }
      if (key.length !== 1) return // Modifier/Steuertasten ignorieren
      if (chars.length > 0 && ts - lastTs > MAX_CHAR_GAP_MS) humanSpeed = true
      chars.push(key)
      lastTs = ts
    },
    reset() { chars = []; humanSpeed = false },
  }
}

// Spiegel des Backend-Vertrags (src/modules/warehouse/codes.ts) — bewusst dupliziert,
// damit das Frontend offline klassifizieren kann. Aenderungen IMMER beidseitig.
const PLACE_RE = /^([A-Za-z]+\d+)\+F(\d+)\+P(\d+)\+EB(\d+)$/
const PALETTE_RE = /^SLW1\|PAL\|(P-\d+)$/
// Klartext-Nummer wie auf dem Zettel gedruckt (manuelle Eingabe) — case-insensitiv,
// Spiegel von PALETTE_BARE_RE im Backend (codes.ts).
const PALETTE_BARE_RE = /^p-\d+$/i

export type FrontendScan =
  | { kind: 'palette'; paletteNo: string }
  | { kind: 'place'; barcode: string; levelNo: number }
  | { kind: 'unknown'; raw: string }

export function classifyScanFrontend(raw: string): FrontendScan {
  const cleaned = raw.trim()
  const pal = PALETTE_RE.exec(cleaned)
  if (pal) return { kind: 'palette', paletteNo: pal[1]! }
  if (PALETTE_BARE_RE.test(cleaned)) return { kind: 'palette', paletteNo: cleaned.toUpperCase() }
  const pl = PLACE_RE.exec(cleaned)
  if (pl) return { kind: 'place', barcode: cleaned, levelNo: parseInt(pl[4]!, 10) }
  return { kind: 'unknown', raw: cleaned }
}
